import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { PqrClosing } from '../../../../../../shared/types/modules/pqr';
import { PqrClosingProps } from './props';
import {
    asyncGetParamByCode,
    asyncGetParamById,
    asyncGetParams,
} from '../../../../../../services/param.service';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';

export const usePqrClosing = ({
    data,
    onChangeData,
    onChangeFormik,
    isSample,
    status,
}: PqrClosingProps) => {
    const [isClose, setIsClose] = useState<boolean>(false);
    const [complianceTerms, setComplianceTerms] = useState<ISelect[]>([]);
    const [nonComplianceReasons, setNonComplianceReasons] = useState<ISelect[]>(
        []
    );
    const [compensation, setTypeCompensation] = useState<ISelect[]>([]);
    const [typeCompensationParam, setTypeCompensations] = useState<ISelect>();

    const onSubmit = (data: PqrClosing) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(isSample),
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('observation', data?.observation || '');
        formik?.setFieldValue('complianceTerms', data?.complianceTerms || '');
        formik?.setFieldValue(
            'nonComplianceReason',
            data?.nonComplianceReason || ''
        );
        formik?.setFieldValue('compensation', data?.compensation || false);
        formik?.setFieldValue(
            'auditObservations',
            data?.auditObservations || ''
        );
        formik?.setFieldValue(
            'audit',
            !data?.audit ? isSample : data?.audit || false
        );
        formik?.setFieldValue(
            'emailNotification',
            data?.emailNotification || false
        );
        formik?.setFieldValue(
            'typeCompensation',
            useGetNameOrValue(data?.typeCompensation || '')
        );
    }, [data, isSample]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_CLOSING_COMPLIANCE_TERMS).then((items) =>
            setComplianceTerms(items)
        );
        asyncGetParams(ParamEnum.PQR_CLOSING_NON_COMPLIANCE_REASON).then(
            (items) => setNonComplianceReasons(items)
        );
    }, []);

    useEffect(() => {
        if (status) {
            asyncGetParamById(status).then((items) =>
                setIsClose(items?.code === 'PQR_STATUS_CER')
            );
        }
    }, [status]);

    useEffect(() => {
        asyncGetParams(ParamEnum.TYPE_COMPENSATION).then((items) =>
            setTypeCompensation(items)
        );
        asyncGetParamByCode(`${ParamEnum.TYPE_COMPENSATION}`).then((item) =>
            setTypeCompensations(item)
        );
    }, []);

    useEffect(() => {
        formik?.setFieldValue('pqrTypeCompensation', '');
        formik?.setFieldValue('observations', '');
    }, [formik.values.typeCompensation]);

    return {
        formik,
        complianceTerms,
        nonComplianceReasons,
        isClose,
        compensation,
        typeCompensationParam,
    };
};
